module.exports = {"320508001":"双塔街道","320508002":"沧浪街道","320508003":"胥江街道","320508004":"吴门桥街道","320508005":"葑门街道","320508006":"友新街道","320508007":"观前街道","320508008":"平江街道","320508009":"苏锦街道","320508010":"娄门街道","320508011":"城北街道","320508012":"桃花坞街道","320508013":"石路街道","320508014":"金阊街道","320508015":"留园街道","320508016":"虎丘街道","320508017":"白洋湾街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320508.json
// module id = 803
// module chunks = 0